import React, { useEffect, useRef, useState } from 'react';
import { components, OptionProps } from 'react-select';

import Tooltip from '@components/common/Tooltip';

import { TSelectOptionType } from '@components/common/Select/Select.types';

import styles from './OptionTruncationOnly.module.scss';

const OptionTruncationOnly = (props: OptionProps<TSelectOptionType, false>) => {
	const { label, data } = props;

	const [isTextTruncated, setIsTextTruncated] = useState(false);

	const labelTextRef = useRef<HTMLSpanElement | null>(null);

	useEffect(() => {
		const element = labelTextRef.current;

		if (!element) return;

		const updateIsTextTruncated = () => {
			const isTruncated = element.scrollWidth - element.clientWidth > 1;
			setIsTextTruncated(isTruncated);
		};

		updateIsTextTruncated();

		const resizeObserver = new ResizeObserver(updateIsTextTruncated);

		resizeObserver.observe(element);

		window.addEventListener('resize', updateIsTextTruncated);

		return () => {
			resizeObserver.disconnect();
			window.removeEventListener('resize', updateIsTextTruncated);
		};
	}, [label]);

	const tooltipContent =
		isTextTruncated ? (data?.tooltipText || String(label ?? '')) : undefined;

	const isOuterTooltipDisabled = !tooltipContent;

	return (
		<Tooltip
			content={tooltipContent}
			isDisabled={isOuterTooltipDisabled}
			subContent={data?.subText}
		>
			<div>
				<components.Option {...props}>
					<span
						ref={labelTextRef}
						className={styles.f5gOptionSingleLabel}
					>
						{label}
					</span>
				</components.Option>
			</div>
		</Tooltip>
	);
};

export default OptionTruncationOnly;
